import { createHelpers } from 'vuex-map-fields'
import { MAP_PAGE } from '../store/modules'

const { mapFields } = createHelpers({
  getterType: `${MAP_PAGE}/getField`,
  mutationType: `${MAP_PAGE}/updateField`
})

export default {
  computed: {
    ...mapFields(['travelData', 'selection']),
    travelSelection () {
      return this.travelData[this.selection]
    }
  }
}
